import { SupportedLanguage } from './language.types';
import { KYCStatus } from './kyc.types';
export const BROADCAST_TITLE_MAX = 100;
export const BROADCAST_BODY_MAX = 500;
export const BROADCAST_PUSH_TTL_SECONDS = 259200;
export const BROADCAST_IDEMPOTENCY_KEY_PATTERN = /^[A-Za-z0-9_-]{16,128}$/;
export var BroadcastStatus;
(function (BroadcastStatus) {
    BroadcastStatus["SENDING"] = "SENDING";
    BroadcastStatus["COMPLETED"] = "COMPLETED";
    BroadcastStatus["FAILED"] = "FAILED";
})(BroadcastStatus || (BroadcastStatus = {}));
export const BROADCAST_LANGUAGES = [
    SupportedLanguage.DE,
    SupportedLanguage.EN,
    SupportedLanguage.RU,
    SupportedLanguage.PL,
];
export const BROADCAST_FALLBACK_LANGUAGE = SupportedLanguage.DE;
export var BroadcastFilterCombinator;
(function (BroadcastFilterCombinator) {
    BroadcastFilterCombinator["AND"] = "AND";
    BroadcastFilterCombinator["OR"] = "OR";
})(BroadcastFilterCombinator || (BroadcastFilterCombinator = {}));
export const BROADCAST_KYC_FILTER_VALUES = [...Object.values(KYCStatus), 'NONE'];
export const BROADCAST_PLANS = ['FREE', 'SMART'];
export const BROADCAST_FILTER_FIELDS = [
    'userStatus',
    'kycStatus',
    'hasTradevestAccount',
    'tradevestProvisioningStatus',
    'paycenterPlan',
    'createdAt',
    'lastLoginAt',
];
export const BROADCAST_FILTER_MAX_CONDITIONS = 20;
//# sourceMappingURL=broadcast.types.js.map